<template>
  <div class="repatcha-disclaimer">
    <p>
      Este site é protegido pelo reCAPTCHA e a
      <a href="https://policies.google.com/privacy?hl=pt-BR" target="_blank">
        Politica de Privacidade
      </a>
      e os
      <a href="https://policies.google.com/terms?hl=pt-BR" target="_blank">
        Termos de Serviço
      </a>
      do Google se aplicam.
    </p>
  </div>
</template>

<script>
export default {
  name: 'RecaptchaDisclaimer',
};
</script>

<style lang="scss">
.repatcha-disclaimer {
  text-align: center;
  margin-top: 16px;

  p {
    font-size: 12px;
    font-family: 'DM Sans Regular', Arial, sans-serif;
    color: #4f5963;

    a {
      font-family: 'DM Sans Bold', Arial, sans-serif;
      text-decoration: none;
      color: #161927;
      font-weight: bold;
    }

    a:hover,
    a:visited {
      color: #161927;
    }
  }

  @media screen and (max-width: 599px) {
    p {
      font-size: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RecaptchaDisclaimer/index.vue